var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button } from '@mui/material';
import { useTerminologyTranslation } from '../../app/terminology';
import { useDialog } from '../../hooks';
import { useIsPlanLocked } from '../selectors';
import { AddQueueDialog } from './addQueueDialog';
import { QueuesTable } from './queuesTable';
import { DialogMode } from './types';
var AddQueueButton = function (_a) {
  var handleOpenDialog = _a.handleOpenDialog,
    disabled = _a.disabled;
  var t = useTerminologyTranslation('wizard', {
    keyPrefix: 'queue.form.addQueue'
  }).t;
  return _jsx(Box, __assign({
    display: "flex",
    justifyContent: "flex-start"
  }, {
    children: _jsx(Button, __assign({
      disabled: disabled,
      variant: "outlined",
      sx: {
        textTransform: 'uppercase'
      },
      onClick: function () {
        return handleOpenDialog(DialogMode.Add);
      }
    }, {
      children: t('title')
    }))
  }));
};
export var QueuesStep = function () {
  var _a = useDialog(),
    dialogMode = _a.dialogMode,
    selectedQueue = _a.data,
    handleOpenDialog = _a.handleOpenDialog,
    handleCloseDialog = _a.handleCloseDialog;
  var isPlanLocked = useIsPlanLocked();
  return _jsxs(_Fragment, {
    children: [_jsx(AddQueueButton, {
      handleOpenDialog: handleOpenDialog,
      disabled: isPlanLocked
    }), _jsx(QueuesTable, {
      handleOpenAddQueueDialog: handleOpenDialog
    }), _jsx(AddQueueDialog, {
      mode: dialogMode,
      queueData: selectedQueue,
      open: dialogMode === DialogMode.Add || dialogMode === DialogMode.Update,
      onClose: handleCloseDialog
    })]
  });
};